import Exchange from "../../client/src/contracts/Exchange.json"
import { derived } from 'svelte/store'
import { web3, chainId } from 'svelte-web3'

const ExchangeContractStore = derived([web3, chainId], ([$web3, $chainId]) => {
  if ($chainId && $web3.eth) {
    // Do whatever nececessay to get address from chainId
    let address
    try {
      address = Exchange.networks[$chainId].address
   }
    catch (e) { 
      window.alert("Exchange not on your connected Network. Connect to Rinkeby")
   }
    return new $web3.eth.Contract(Exchange.abi, address, {})
  }
  return null
})
export default ExchangeContractStore